import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vShow as _vShow, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "filters-bar" }
const _hoisted_3 = { class: "date-wrapper" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "officer-filter-wrapper col-sm-2" }
const _hoisted_7 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_8 = { class: "officer-filter-wrapper col-sm-2" }
const _hoisted_9 = { class: "officer-filter-wrapper col-sm-2" }
const _hoisted_10 = { class: "officer-filter-wrapper col-sm-2" }
const _hoisted_11 = { class: "btn-group-wrapper" }
const _hoisted_12 = { class: "text-yellow" }
const _hoisted_13 = { class: "adjustment-checkbox" }
const _hoisted_14 = {
  key: 0,
  class: "drag-feedback"
}
const _hoisted_15 = { class: "drag-feedback-content" }
const _hoisted_16 = {
  key: 1,
  class: "copy-banner"
}
const _hoisted_17 = {
  key: 3,
  class: "loading-overlay"
}
const _hoisted_18 = { class: "toast-content" }
const _hoisted_19 = { class: "toast-icon" }
const _hoisted_20 = { class: "toast-message" }
const _hoisted_21 = { class: "text-danger h2" }
const _hoisted_22 = {
  key: 6,
  class: "grand-total-banner"
}
const _hoisted_23 = { class: "grand-total-value" }
const _hoisted_24 = { class: "grand-total-days" }
const _hoisted_25 = {
  key: 0,
  class: "timeline-wrapper"
}
const _hoisted_26 = { class: "grid-header" }
const _hoisted_27 = { class: "day-date" }
const _hoisted_28 = { class: "day-full" }
const _hoisted_29 = { class: "day-total" }
const _hoisted_30 = { class: "grid-body" }
const _hoisted_31 = { class: "grid-cell time-cell" }
const _hoisted_32 = ["onDragover", "onDrop", "onContextmenu"]
const _hoisted_33 = ["draggable", "onContextmenu", "onClick", "onDblclick", "onDragstart"]
const _hoisted_34 = {
  key: 0,
  class: "job-checkbox"
}
const _hoisted_35 = ["checked"]
const _hoisted_36 = ["title", "onClick"]
const _hoisted_37 = { class: "job-seq-circle" }
const _hoisted_38 = ["title"]
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "job-meta" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "job-duration" }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "grid-header bottom-header" }
const _hoisted_45 = { class: "day-date" }
const _hoisted_46 = { class: "day-full" }
const _hoisted_47 = { class: "day-total" }
const _hoisted_48 = {
  key: 1,
  class: "no-data"
}
const _hoisted_49 = {
  key: 2,
  class: "no-data"
}
const _hoisted_50 = {
  key: 3,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpeechSchedule = _resolveComponent("SpeechSchedule")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_JobModal = _resolveComponent("JobModal")!
  const _component_RightToWorkCheckPopup = _resolveComponent("RightToWorkCheckPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SpeechSchedule, {
      baseUrl: _ctx.baseUrl,
      onScheduleLoaded: _ctx.onScheduleLoaded
    }, null, 8, ["baseUrl", "onScheduleLoaded"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            type: "date",
            value: _ctx.startDateInput,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateStartDate($event)))
          }, null, 40, _hoisted_4),
          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "date-separator" }, "to", -1)),
          _createElementVNode("input", {
            type: "date",
            value: _ctx.endDateInput,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateEndDate($event)))
          }, null, 40, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selectedCompanyId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCompanyId) = $event)),
            options: _ctx.companies.map(o => ({ value: o.companyId, label: o.companyName })),
            placeholder: "Select Client...",
            searchable: true,
            clearable: true
          }, null, 8, ["modelValue", "options"])
        ]),
        (_ctx.isLoadingCompanies)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Loading clients..."))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selectedOfficerId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedOfficerId) = $event)),
            options: _ctx.officers.map(o => ({ value: o.id, label: o.name })),
            placeholder: "Select officer...",
            searchable: true,
            clearable: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selectedSiteId,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedSiteId) = $event)),
            options: _ctx.sites.map(s => ({ value: s.id, label: s.name })),
            placeholder: "Select site...",
            searchable: true,
            clearable: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selectedGroupIds,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedGroupIds) = $event)),
            mode: "tags",
            "close-on-select": false,
            options: _ctx.officerGroups.map(g => ({ value: g.id, label: g.name })),
            placeholder: "Select group(s)...",
            searchable: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm m-1",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.OnAddJobCliked && _ctx.OnAddJobCliked(...args)))
          }, [...(_cache[25] || (_cache[25] = [
            _createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1),
            _createTextVNode(" Add Job ", -1)
          ]))]),
          _createElementVNode("button", {
            class: "btn btn-danger btn-sm m-1",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleSelectMode()))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["bi", _ctx.selectMode ? 'bi-x-circle' : 'bi-check-circle'])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.selectMode ? 'Cancel' : 'Select Mode'), 1)
          ]),
          (_ctx.selectMode && _ctx.selectedJobIds.size > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-danger btn-sm m-1",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteSelectedJobs()))
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("i", {
                  class: "bi bi-trash-fill",
                  style: {"color":"black"}
                }, null, -1)),
                _createElementVNode("span", _hoisted_12, "Delete (" + _toDisplayString(_ctx.selectedJobIds.size) + ")", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-success btn-sm m-1",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)))
          }, [...(_cache[27] || (_cache[27] = [
            _createElementVNode("i", { class: "bi bi-file-excel" }, null, -1),
            _createTextVNode(" Export Excel ", -1)
          ]))])
        ]),
        _createElementVNode("label", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.includeAdjustment) = $event)),
            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getScheduleForToday()))
          }, null, 544), [
            [_vModelCheckbox, _ctx.includeAdjustment]
          ]),
          _cache[28] || (_cache[28] = _createElementVNode("span", null, "⏱️ Include Adjustment Hours", -1))
        ])
      ]),
      (_ctx.isDragging)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, "📋 Creating jobs from " + _toDisplayString(_ctx.dragSourceDate) + " to " + _toDisplayString(_ctx.dragTargetDate) + " (" + _toDisplayString(_ctx.dateRangeCount) + " days)", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.copiedJob && !_ctx.isDragging)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("span", null, "📋 Copied: " + _toDisplayString(_ctx.copiedJob.securityOfficerInfo) + " · " + _toDisplayString(_ctx.copiedJob.siteInfo) + " (" + _toDisplayString(_ctx.formatTimeSpan(_ctx.copiedJob.startTime)) + "–" + _toDisplayString(_ctx.formatTimeSpan(_ctx.copiedJob.endTime)) + "). Right-click a date to paste (Esc to cancel)", 1),
            _createElementVNode("button", {
              class: "copy-banner-close",
              onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearCopiedJob && _ctx.clearCopiedJob(...args)), ["stop"]))
            }, "×")
          ]))
        : _createCommentVNode("", true),
      (_ctx.contextMenu.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "context-menu",
            style: _normalizeStyle({ top: _ctx.contextMenu.y + 'px', left: _ctx.contextMenu.x + 'px' }),
            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
            onContextmenu: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (_ctx.contextMenu.job)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "context-menu-item",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.copyJob(_ctx.contextMenu.job)))
                }, " 📋 Copy Job "))
              : _createCommentVNode("", true),
            (_ctx.copiedJob && _ctx.contextMenu.day)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "context-menu-item",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.pasteJob(_ctx.contextMenu.day, _ctx.contextMenu.hour ?? 0)))
                }, " 📥 Paste Job Here (" + _toDisplayString(_ctx.formatDayLabel(_ctx.contextMenu.day.date)) + ", " + _toDisplayString(_ctx.formatTimeSpan(_ctx.copiedJob.startTime)) + "–" + _toDisplayString(_ctx.formatTimeSpan(_ctx.copiedJob.endTime)) + ") ", 1))
              : _createCommentVNode("", true),
            (_ctx.copiedJob)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "context-menu-item",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clearCopiedJob && _ctx.clearCopiedJob(...args)))
                }, " ✖ Clear Copied Job "))
              : _createCommentVNode("", true)
          ], 36))
        : _createCommentVNode("", true),
      (_ctx.isCreatingJobs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
            _createElementVNode("div", null, "Creating " + _toDisplayString(_ctx.jobsToCreate) + " job(s)...", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showToast)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass(["toast-container", _ctx.toastType])
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.toastIcon), 1),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.toastMessage), 1),
              _createElementVNode("button", {
                class: "toast-close",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args)))
              }, "×")
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_JobModal, {
        ref: "jobModal",
        baseUrl: _ctx.baseUrl,
        officers: _ctx.officers,
        officerGroups: _ctx.officerGroups,
        defaultGroupIds: _ctx.selectedGroupIds,
        sites: _ctx.sites,
        jobStatuses: _ctx.jobStatuses,
        onJobAdded: _ctx.getScheduleForToday,
        onJobUpdated: _ctx.getScheduleForToday,
        onRightToWorkSaved: _ctx.checkOfficerEligibilityBulk
      }, null, 8, ["baseUrl", "officers", "officerGroups", "defaultGroupIds", "sites", "jobStatuses", "onJobAdded", "onJobUpdated", "onRightToWorkSaved"]),
      (_ctx.rightToWorkOfficerId)
        ? (_openBlock(), _createBlock(_component_RightToWorkCheckPopup, {
            key: 5,
            baseUrl: _ctx.baseUrl || '',
            officerId: _ctx.rightToWorkOfficerId,
            onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.rightToWorkOfficerId = null)),
            onSaved: _ctx.checkOfficerEligibilityBulk
          }, null, 8, ["baseUrl", "officerId", "onSaved"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("span", _hoisted_21, "Please make sure you are logged in.", 512), [
          [_vShow, !_ctx.isAuthorized]
        ])
      ]),
      (_ctx.dayList.length > 0 && _ctx.hasScheduleData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "grand-total-icon" }, "📊", -1)),
            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "grand-total-label" }, "Grand Total:", -1)),
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.grandTotalHours), 1),
            _createElementVNode("span", _hoisted_24, "(" + _toDisplayString(_ctx.dayList.length) + " days)", 1)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["schedule-grid", { 'select-mode-active': _ctx.selectMode }])
      }, [
        (_ctx.dayList.length > 0 && _ctx.hasAnyJobs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "header-cell time-header" }, "Time", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (day) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: day.dateKey,
                    class: "header-cell day-header"
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatDayLabel(day.date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, "⏱️ " + _toDisplayString(_ctx.dailyTotalHours[day.dateKey]), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHourList, (hour) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: hour,
                    class: "grid-row"
                  }, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formatHourLabel(hour)), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: day.dateKey + '-' + hour,
                        class: _normalizeClass(["grid-cell slot-cell", { 
            'drag-over': _ctx.isDragOver && _ctx.dragOverKey === `${day.dateKey}-${hour}`,
            'has-conflict': _ctx.hasJobConflict(day, hour)
          }]),
                        onDragover: _withModifiers(($event: any) => (_ctx.onDragOver(day, hour)), ["prevent"]),
                        onDragleave: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
                        onDrop: _withModifiers(($event: any) => (_ctx.onDrop(day, hour)), ["prevent"]),
                        onContextmenu: ($event: any) => (_ctx.openContextMenu($event, day, hour, null))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobsForSlot(day, hour), (duty) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: duty.jobId,
                            class: _normalizeClass(["job-block", [
                  _ctx.setStatusColor(duty.statusId),
                  { 'job-selected': _ctx.selectMode && _ctx.selectedJobIds.has(duty.jobId) },
                  { 'tbc-officer': duty.securityOfficerInfo && duty.securityOfficerInfo.toLowerCase().startsWith('tbc') },
                  { 'has-eligibility-issue': _ctx.hasEligibilityIssue(duty.jobId) },
                  { 'job-locked': _ctx.isJobLocked(duty) },
                  { 'job-copied': _ctx.copiedJob && _ctx.copiedJob.jobId === duty.jobId }
                ]]),
                            draggable: !_ctx.selectMode,
                            onContextmenu: _withModifiers(($event: any) => (_ctx.openContextMenu($event, day, hour, duty)), ["stop"]),
                            onClick: ($event: any) => (_ctx.selectMode ? _ctx.toggleJobSelection(duty.jobId) : _ctx.openEditJob(duty)),
                            onDblclick: ($event: any) => (!_ctx.selectMode && _ctx.openEditJob(duty)),
                            onDragstart: ($event: any) => (!_ctx.selectMode && _ctx.onDragStart($event, duty, day, hour)),
                            onDragend: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)))
                          }, [
                            (_ctx.selectMode)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.selectedJobIds.has(duty.jobId),
                                    onChange: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 40, _hoisted_35)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.hasEligibilityIssue(duty.jobId))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass(["eligibility-warning-icon", { 'rtw-clickable': _ctx.canOpenRightToWork(duty) }]),
                                  title: _ctx.getEligibilityTooltip(duty),
                                  onClick: _withModifiers(($event: any) => (_ctx.onEligibilityIconClick(duty)), ["stop"]),
                                  onDblclick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                                }, "⚠️", 42, _hoisted_36))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.jobSequenceMap[duty.jobId]), 1),
                            _createElementVNode("div", {
                              class: "job-title",
                              title: duty.securityOfficerInfo
                            }, _toDisplayString(_ctx.formatOfficerName(duty.securityOfficerInfo, _ctx.dayList.length)), 9, _hoisted_38),
                            _createElementVNode("div", {
                              class: "job-site-name",
                              title: duty.siteInfo
                            }, _toDisplayString(_ctx.formatSiteName(duty.siteInfo, _ctx.dayList.length)), 9, _hoisted_39),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("span", {
                                class: "job-time",
                                title: _ctx.getTimeTooltip(duty)
                              }, _toDisplayString(_ctx.formatTimeSpan(duty.startTime)) + "–" + _toDisplayString(_ctx.formatTimeSpan(duty.endTime)), 9, _hoisted_41),
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.calculateJobDuration(duty.startTime, duty.endTime)), 1),
                              _createElementVNode("span", {
                                class: "job-client",
                                title: duty.clientInfo
                              }, _toDisplayString(_ctx.formatClientName(duty.clientInfo, _ctx.dayList.length)), 9, _hoisted_43)
                            ])
                          ], 42, _hoisted_33))
                        }), 128))
                      ], 42, _hoisted_32))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_44, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "header-cell time-header" }, "Time", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (day) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'bottom-' + day.dateKey,
                    class: "header-cell day-header"
                  }, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.formatDayLabel(day.date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, "⏱️ " + _toDisplayString(_ctx.dailyTotalHours[day.dateKey]), 1)
                  ]))
                }), 128))
              ])
            ]))
          : (_ctx.dayList.length > 0 && !_ctx.hasAnyJobs && _ctx.isAuthorized && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, " No jobs found for selected dates "))
            : (_ctx.dayList.length === 0 && _ctx.isAuthorized && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, " No schedule data available for selected dates "))
              : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, " Loading schedule data... "))
          : _createCommentVNode("", true)
      ], 2), [
        [_vShow, _ctx.isAuthorized]
      ])
    ])
  ], 64))
}